"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = void 0;
var reducer = function (state, action) {
    switch (action.type) {
        case 'move':
            var lastChild = state.children[state.children.length - 1];
            var children = state.children.slice(0, -1);
            return __assign(__assign(__assign({}, state), { children: children, dropdownItems: __spreadArray([lastChild], state.dropdownItems) }), (action.payload.lastItem && {
                lastItemWidth: __spreadArray(__spreadArray([], state.lastItemWidth), [
                    action.payload.lastItem.clientWidth,
                ]),
            }));
        case 'return':
            var _a = state.dropdownItems, firstItemFromList = _a[0], dropdownItems = _a.slice(1);
            var _b = state.lastItemWidth, _1 = _b[0], lastItemWidth = _b.slice(1);
            return {
                children: __spreadArray(__spreadArray([], state.children), [firstItemFromList]),
                dropdownItems: dropdownItems,
                lastItemWidth: lastItemWidth,
            };
        case 'reset':
            return action.payload;
        default:
            return state;
    }
};
exports.reducer = reducer;
